module.exports = __webpack_public_path__ + "static/portrait-antje-abel-39442775acf741903af7cea9cca9c4ee.jpg";